export { default } from './Opening'